// Import Core
import React from "react";
import styled from "styled-components";
// Import Assets
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import Stars from "../ui/Stars";

const AccordionCheckboxStyling = styled.div`
  -webkit-tap-highlight-color: transparent !important;
  &:focus,
  &:visited,
  &:active {
    outline: none !important;
  }
  padding: 20px 0;
  border-top: 1px solid var(--neutral-25);
  border-top: 1px solid var(--neutral-25);
  width: 100%;
  cursor: pointer;
  @media (max-width: 768px) {
    padding: 16px 0;
  }
  &:last-child {
    border-bottom: 1px solid var(--neutral-25);
    padding-bottom: 20px;
  }
  .accordion-title {
    display: flex;
    width: 100%;
    justify-content: space-between;
    h5 {
      text-transform: uppercase;
    }
    svg {
      width: 20px;
      height: 100%;
      color: var(--black);
    }
  }
  .accordion-content {
    scrollbar-width: thin;
    scrollbar-color: var(--red) var(--neutral-5);
    &::-webkit-scrollbar {
      display: none !important;
    }
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: fit-content;
    max-height: 200px;
    overflow-y: auto;
    @media (max-width: 992px) {
      max-height: unset;
      overflow-y: auto;
    }
    .accordion-checkbox {
      display: flex;
      padding: 8px 0px;
      align-items: center;
      gap: 12px;
      width: 100%;
      &:active {
        outline: none;
        border: none;
      }
    }
    .option-name {
      display: flex;
      justify-content: space-between;
      width: 100%;}
  }
`;

const AccordionCheckbox = ({
  index,
  content,
  toggleAccordion,
  handleCheckboxChangeAndLog,
}) => {
  let contentJsx = content.checkboxes.map((checkbox, checkboxIndex) => {
    // if (checkbox.visible === undefined) {
    if (content.title !== "Star Rating") {
      return (
        <label key={checkboxIndex} className="accordion-checkbox">
          <input
            type="checkbox"
            checked={checkbox.isChecked}
            onChange={() => handleCheckboxChangeAndLog(index, checkboxIndex)}
          />
          <div className="option-name">
            <span>{` ${checkbox.name}`}</span>
            <span>{checkbox.number ? ` (${checkbox.number})` : ""}</span>
          </div>
        </label>
      );
    } else {
      return (
        <label key={checkboxIndex} className="accordion-checkbox">
          <input
            type="checkbox"
            checked={checkbox.isChecked}
            onChange={() => handleCheckboxChangeAndLog(index, checkboxIndex)}
          />
          <div className="option-name">
            <div>
              <Stars starRating={checkbox.name} />
            </div>
            <span>{checkbox.number ? ` (${checkbox.number})` : ""}</span>
          </div>
        </label>
      );
    }
    // }else{
    //   if(checkbox.visible){
    //     if (content.title !== "Star Rating") {
    //       return (
    //         <label key={checkboxIndex} className="accordion-checkbox">
    //           <input
    //             type="checkbox"
    //             checked={checkbox.isChecked}
    //             onChange={() => handleCheckboxChangeAndLog(index, checkboxIndex)}
    //           />
    //           {` ${checkbox.name}`}
    //         </label>
    //       );
    //     } else {
    //       return (
    //         <label key={checkboxIndex} className="accordion-checkbox">
    //           <input
    //             type="checkbox"
    //             checked={checkbox.isChecked}
    //             onChange={() => handleCheckboxChangeAndLog(index, checkboxIndex)}
    //           />
    //           <div>
    //             <Stars starRating={checkbox.name} />
    //           </div>
    //         </label>
    //       );
    //     }
    //   }
    // }
  });
  return (
    <AccordionCheckboxStyling className="accordion-item" key={content.id}>
      <div className="accordion-title" onClick={() => toggleAccordion(index)}>
        <h5 className="tk-trajan-pro-3">{content.title}</h5>
        {content.isOpen ? <FaChevronUp /> : <FaChevronDown />}
      </div>
      {content.isOpen && <div className="accordion-content">{contentJsx}</div>}
    </AccordionCheckboxStyling>
  );
};

export default AccordionCheckbox;
